// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_1OULfUXc9JT58gV5FqKoxC"};